import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormControl } from '@material-ui/core';
import { ERROR_POSITION } from '%app/js/common/components/material/errors/config/constants';
import ErrorList from './errors';

const withFormControl = (WrappedComponent) => {
    class FormControlWrapper extends PureComponent {
        render() {
            const {
                meta: { error, touched, submitFailed },
                meta,
                errorPosition,
                input,
                errors: externalErrors,
                ...rest
            } = this.props;

            const showError = ((touched || submitFailed) && typeof error === 'object') || externalErrors !== null;
            const errorList = externalErrors !== null ? externalErrors : error;
            const renderedError = showError && <ErrorList errors={errorList} />;

            const fixedInput = {
                ...input,
                onDragStart: input.onDragStart ? input.onDragStart : () => {},
                onDrop: input.onDrop ? input.onDrop : () => {},
            };

            return (
                <FormControl fullWidth>
                    {errorPosition === ERROR_POSITION.top && renderedError}
                    <WrappedComponent
                        meta={meta}
                        input={fixedInput}
                        errors={externalErrors}
                        {...rest}
                    />

                    {errorPosition === ERROR_POSITION.bottom && renderedError}
                </FormControl>
            );
        }
    }

    FormControlWrapper.propTypes = {
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
        errorPosition: PropTypes.string,
        meta: PropTypes.shape({
            touched: PropTypes.bool,
            submitFailed: PropTypes.bool,
            error: PropTypes.oneOfType([
                PropTypes.arrayOf(PropTypes.string),
                PropTypes.object,
                PropTypes.bool,
            ]),
        }).isRequired,
        errors: PropTypes.any,
    };

    FormControlWrapper.defaultProps = {
        errorPosition: ERROR_POSITION.bottom,
        errors: null,
    };

    return FormControlWrapper;
};

export default withFormControl;
